export function getDeviceLocale() {
	if (navigator.languages?.length > 0) {
		return navigator.languages[0];
	} else if (navigator.language) {
		return navigator.language;
	}
	return "en-US";
}

export function getDeviceLanguage() {
	return getDeviceLocale().slice(0, 2);
}

/**
 * e.g. `12/25/2024`
 */
export const NumericDateFormat: Intl.DateTimeFormatOptions = {
	year: "numeric",
	month: "numeric",
	day: "numeric",
};

/**
 * e.g. `Dec 25, 2024`
 */
export const ShortDateFormat: Intl.DateTimeFormatOptions = {
	year: "numeric",
	month: "short",
	day: "numeric",
};

/**
 * e.g. `Dec 25`
 */
export const MonthDayFormat: Intl.DateTimeFormatOptions = {
	month: "short",
	day: "numeric",
};

/**
 * e.g. `December 25, 2024 at 10:30 AM`
 */
export const DateAndTimeFormat: Intl.DateTimeFormatOptions = {
	year: "numeric",
	month: "long",
	day: "numeric",
	hour: "numeric",
	minute: "numeric",
};
